import type { MatrixClient } from 'matrix-js-sdk';
import { useMediaUrl } from '../../lib/matrix/media.js';
import { useMatrixClient } from '../../lib/matrix/useMatrix.js';
import { usePersonPhoto, userIdOf } from '../../lib/matrix/photos.js';
import './person-photo.css';

/**
 * Foto de verdade por cima do avatar: quando a pessoa tem foto, ela cobre o
 * círculo inteiro; quando não tem, continua aparecendo o que está embaixo (as
 * iniciais do `PersonAvatar` ou, no avatar de quem usa o app, o personagem).
 */
export function PhotoOver({ url }: { url: string | null }) {
  if (!url) return null;
  return <img className="person-photo" src={url} alt="" />;
}

/** Foto a partir de um endereço já conhecido (ex.: participante da conversa). */
export function MxcPhoto({ client, mxc }: { client: MatrixClient | null; mxc: string | null }) {
  const photo = useMediaUrl(client, mxc ? { url: mxc, mime: 'image/jpeg' } : null);
  return <PhotoOver url={photo.url} />;
}

/** Foto de um contato que está no Secretário, pelo @usuário. */
export function ContactPhoto({ username }: { username: string | null | undefined }) {
  const { client } = useMatrixClient();
  const url = usePersonPhoto(client, client && username ? userIdOf(client, username) : null);
  return <PhotoOver url={url} />;
}

/** A foto de quem está usando o app. Carregado sob demanda pelo cabeçalho. */
export default function MePhoto() {
  const { client } = useMatrixClient();
  const url = usePersonPhoto(client, client?.getUserId() ?? null);
  return <PhotoOver url={url} />;
}
